import React, { useMemo } from 'react'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { FoldPagePresentationBrandV2 } from '@nsw-paginas-deslogadas/components'
import FoldAboutNavV2 from '@nsw-paginas-deslogadas/components/FoldAboutNavV2'
import FoldFaqV2 from '@nsw-paginas-deslogadas/components/FoldFaqV2'

const LandingPageV2: React.FC = () => {
    const { brand } = useAppContext()
    const brandMap = BrandMapping[brand.mappingId]

    const questionsByBrand = useMemo(() => {
        return BrandMapping[brand.mappingId].questions
    }, [brand.mappingId])

    return (
        <>
            <FoldPagePresentationBrandV2 />
            <FoldFaqV2
                examLink={brandMap.buttons.faq.exams}
                questions={questionsByBrand}
                vaccineActive={brandMap.buttons.faq.vaccineActive}
                vaccineLink={brandMap.buttons.faq.vaccines}
            />
            <FoldAboutNavV2 />
        </>
    )
}

export default LandingPageV2
